/**
 * Money precision — the SINGLE knob for iteach.
 *
 * `MONEY_DECIMALS` decides how many decimals money is rounded to and shown at.
 * Default 2 = current production. Set to 8 ONLY after client approval AND the
 * decimal(15,8) DB migration. Keep in sync with nodefork (src/utils/money/money.util.ts)
 * and ilearn (src/_config/money.js).
 */

/** The one knob. */
export const MONEY_DECIMALS = 2;

const FACTOR = 10 ** MONEY_DECIMALS;

/** Round a money value to MONEY_DECIMALS places. */
export const roundMoney = (n: number): number =>
  Math.round((Number(n) || 0) * FACTOR) / FACTOR;

/** `<input type="number">` step for a money field: "0.01" @2, "0.00000001" @8. */
export const MONEY_STEP: string = (10 ** -MONEY_DECIMALS).toFixed(MONEY_DECIMALS);

/**
 * Display a money value: 2 decimals minimum (money still reads as money), up to
 * MONEY_DECIMALS. `en-IN` grouping to match the app's rupee formatting.
 */
export const fmtMoney = (n: number): string =>
  (Number(n) || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: MONEY_DECIMALS,
  });
